export default __webpack_public_path__ + "static/task-definition-ec2-f3a885d34c9e479f61c30982143362f5.png";